/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Record_string_string_ } from './Record_string_string_';
export type WebsiteTemplateRegistryUploadSessionRecord = {
    uploadSessionId: string;
    uploadUrl: string;
    uploadMethod: WebsiteTemplateRegistryUploadSessionRecord.uploadMethod;
    uploadHeaders: Record_string_string_;
    objectKey: string;
    expiresAt: string;
};
export namespace WebsiteTemplateRegistryUploadSessionRecord {
    export enum uploadMethod {
        PUT = 'PUT',
    }
}

